import { render, staticRenderFns } from "./DecimalPlaces.vue?vue&type=template&id=65a773b0&lang=pug"
import script from "./DecimalPlaces.vue?vue&type=script&lang=js"
export * from "./DecimalPlaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports